import { jsPDF } from "jspdf";
import Headerimg from '../../../../utils/header.jpeg';
import Footerimg from '../../../../utils/footer.jpeg';
import { formatMiles } from "../../../../utils/miles";

/**
 * Ajuste aplicado:
 *  - Todos los textos mostrados se transforman a "Primera Letra Mayúscula y resto minúscula"
 *    (Title Case simple por palabra) usando formatText.
 *  - Se aplica a encabezados, subtotales, nombres, procedimientos, usuarios, conceptos,
 *    descripciones de gastos y nombre de archivo.
 *  - Números y fechas se mantienen sin cambio.
 */

function formatText(txt) {
  if (txt === null || txt === undefined) return "";
  const base = txt.toString().toLowerCase();
  return base.replace(/[\p{L}\p{M}]+/gu, word => word.charAt(0).toUpperCase() + word.slice(1));
}

function Bodyrows(Sumatotal, Sumgastos, Sumasistencias) {
  return [
    [formatText("Enfermeria"), Sumatotal.toLocaleString('es')],
    [formatText("Otros Servicios"), Sumgastos.toLocaleString('es')],
    [formatText("Asistencias"), Sumasistencias.toLocaleString('es')],
    [formatText("Total"), (Sumgastos + Sumatotal + Sumasistencias).toLocaleString('es')]
  ];
}

function horasalida(fecha, hora, horas) {
  let fechatotal = new Date(`${fecha} ${hora}`);
  fechatotal.setTime(fechatotal.getTime() + horas * 60 * 60 * 1000);
  const showTime =
    addZeroBefore(fechatotal.getHours()) + ":" +
    addZeroBefore(fechatotal.getMinutes()) + ":" +
    addZeroBefore(fechatotal.getSeconds());
  return showTime;
}

function addZeroBefore(n) {
  return (n < 10 ? "0" : "") + n;
}

const formatTime = (value) => value.split(".")[0];

export default function genPDF(props) {
  const {
    dato,
    tipo,
    inicio,
    fin,
    datgastos,
    Sumgastos,
    Suma,
    Paciente,
    Sumasistencias,
    dataasistencias = [],
    prof
  } = props;

  const txRaw = tipo === 'Honorario' ? 'HONORARIO' : 'LIQUIDACION';
  const tx = formatText(txRaw);
  const Sumatotal = Math.round(Suma);
  const gastos = datgastos || [];

  // Encabezados tablas (formateados)
  const col = [
    formatText("Fecha"),
    formatText("Hora Entrada"),
    formatText("Hora Salida"),
    formatText("Horas"),
    formatText(tipo),
    formatText("Enfermero")
  ];
  const colotros = [
    formatText("Detalle"),
    formatText("Monto"),
    formatText("Fecha")
  ];

  const doc = new jsPDF();
  const xOffset = doc.internal.pageSize.width / 2;
  const totalPagesExp = "{total_pages_count_string}";

  // Títulos
  doc.setFontSize(20);
  doc.text(formatText(prof), xOffset, 50, { align: "center" });
  doc.setFontSize(15);
  doc.setTextColor(112, 112, 112);
  doc.text(formatText(Paciente), xOffset, 56, { align: "center" });
  doc.setTextColor(0, 0, 0);

  // MARCACIONES
  const rows = [];
  let totalhoras = 0;

  dato.forEach((element, key, arr) => {
    const HoraSalida = horasalida(
      element.Fecha,
      element.HoraEntrada,
      element.horascalculadas + element.horashoraextra
    );
    const HorasCalculadas =
      Number(element.horascalculadas) +
      Number(Number(element.horashoraextra).toFixed(2));

    const calculo =
      tipo === "Tarifa"
        ? Math.round(
            element.CostoHoraEmpresa * HorasCalculadas +
            (element.CostoHoraEmpresa * element.horasferiado * element.porcentajeferiado) / 100
          ).toLocaleString("es")
        : Math.round(
            element.CostoHoraProfesional * HorasCalculadas +
            (element.CostoHoraProfesional * element.horasferiado * element.porcentajeferiado) / 100
          ).toLocaleString("es");

    rows.push([
      element.Fecha,
      formatTime(element.HoraEntrada + ""),
      HoraSalida,
      HorasCalculadas.toFixed(2),
      calculo,
      formatText(element.Usuario)
    ]);

    totalhoras += HorasCalculadas;

    if (Object.is(arr.length - 1, key)) {
      rows.push([
        formatText("Subtotal"),
        "",
        "",
        totalhoras.toFixed(2),
        Sumatotal.toLocaleString('es'),
        ""
      ]);
    }
  });

  // OTROS SERVICIOS
  const rowotros = [];
  gastos.forEach((element, key, arr) => {
    rowotros.push([
      formatText(element.gasto),
      element.monto ? formatMiles(element.monto) : formatMiles(Sumgastos),
      element.fecha || ""
    ]);
    if (Object.is(arr.length - 1, key)) {
      rowotros.push([
        formatText("Subtotal"),
        formatMiles(Sumgastos)
      ]);
    }
  });

  // Tabla: OTROS SERVICIOS
  doc.autoTable({
    head: [[{
      content: formatText("Otros Servicios"),
      colSpan: colotros.length,
      styles: { halign: 'center', fontStyle: 'bold', fillColor: [255,255,255], textColor: [0,0,0] }
    }], colotros],
    body: rowotros,
    startY: 65,
    margin: { left: 10, right: 107 },
    willDrawCell: (data) => {
      if (data.row.index === data.table.body.length - 1) doc.setFont(undefined, "bold");
    }
  });
  const otrosServiciosY = doc.lastAutoTable.finalY;

  // Tabla: TOTAL (resumen)
  doc.autoTable({
    head: [[{
      content: formatText("Total"),
      colSpan: 2,
      styles: { halign: 'center', fontStyle: 'bold', fillColor: [255,255,255], textColor: [0,0,0] }
    }], [formatText("Detalle"), formatText("Monto")]],
    body: Bodyrows(Sumatotal, Sumgastos, Sumasistencias),
    startY: 65,
    margin: { right: 10, left: 107 },
    willDrawCell: (data) => {
      if (data.row.index === data.table.body.length - 1) doc.setFont(undefined, "bold");
    }
  });
  const totalTableY = doc.lastAutoTable.finalY;

  const maxY = Math.max(otrosServiciosY, totalTableY) + 10;

  // Tabla: ASISTENCIAS
  const asistenciaRows = dataasistencias.map(a => [
    formatText(a.procedimiento),
    a.fecha,
    (tipo === "Tarifa" ? a.tarifa : a.honorario).toLocaleString('es'),
    formatText(a.usuario)
  ]);
  asistenciaRows.push([
    formatText("Subtotal"),
    "",
    Sumasistencias.toLocaleString('es'),
    ""
  ]);

  doc.autoTable({
    head: [[{
      content: formatText("Asistencias"),
      colSpan: 4,
      styles: { halign: 'center', fontStyle: 'bold', fillColor: [255,255,255], textColor: [0,0,0] }
    }], [
      formatText("Detalle"),
      formatText("Fecha"),
      formatText(tipo),
      formatText("Asignado")
    ]],
    body: asistenciaRows,
    startY: maxY,
    styles: { overflow: 'linebreak', fontSize: 9 },
    margin: { top: 60, right: 10, bottom: 40, left: 10 },
    pageBreak: 'auto',
    rowPageBreak: 'auto',
    willDrawCell: (data) => {
      if (data.row.index === data.table.body.length - 1) doc.setFont(undefined, "bold");
    }
  });

  // Tabla: MARCACIONES
  const afterAsistenciasY = doc.lastAutoTable.finalY;
  doc.autoTable({
    head: [[{
      content: formatText("Marcaciones"),
      colSpan: col.length,
      styles: { halign: 'center', fontStyle: 'bold', fillColor: [255,255,255], textColor: [0,0,0] }
    }], col],
    body: rows,
    startY: afterAsistenciasY,
    margin: { top: 60, right: 10, bottom: 35, left: 10 },
    pageBreak: 'auto',
    rowPageBreak: 'auto',
    willDrawCell: (data) => {
      if (data.row.section === 'body' && data.row.index < rows.length - 1) {
        const rowData = dato[data.row.index];
        if (rowData?.esFeriado === 'SI') {
          doc.setFillColor(255, 255, 0);
          doc.rect(data.cell.x, data.cell.y, data.cell.width, data.cell.height, 'F');
        }
      }
      if (data.row.section === 'body' && data.row.index === rows.length - 1) {
        doc.setFont(undefined, "bold");
      }
    }
  });

  // Header / Footer en cada página
  for (let page = 1; page <= doc.getNumberOfPages(); page++) {
    doc.setPage(page);
    doc.addImage(Headerimg, 'JPEG', 0, 0, 210, 40);
    doc.addImage(Footerimg, 'JPEG', 0, 255, 210, 40);
  }

  if (typeof doc.putTotalPages === 'function') {
    doc.putTotalPages(totalPagesExp);
  }

  doc.save(`${tx} ${formatText(prof)} ${inicio} ${formatText("al")} ${fin}.pdf`);
}

/**
 * Genera y retorna el documento PDF sin guardarlo automáticamente (pdfWriter2).
 * Usado para integración con Tauri. Esta es una versión simplificada - TODO: refactorizar para evitar duplicación.
 */
export function generatePDFDocument(props) {
  // TODO: Esta es una implementación temporal/WIP
  // Por ahora, llamamos a genPDF internamente que usa doc.save()
  // En una versión futura, se debería refactorizar para compartir código
  // y retornar el documento antes de guardarlo.
  
  // Para el WIP/Draft, retornamos un stub que indica que esto necesita implementación completa
  throw new Error("generatePDFDocument for pdfWriter2 - WIP: needs full implementation");
}